<div class="pageHeader">
    <h1 class="pageHeading" style="margin-bottom: 32px; margin-top: 88px; text-align: center;">Rushmore <span style=" color: #828282;"> & </span> YourOwnROOM</h1>
    <div class="row " style="padding: 32px 40px">
        
        <div class="col-md-6 col-12 header" >
            
            <div>
                <p class="contentSubText">Rushmore Estates, Co-Founded by Alok Kumar Singh (IIML, IIT-BHU) and
                    YourOwnROOM, Co-Founded by Prabhat Kumar Tiwary (Stanford GSB, BIT
                    Mesra) have signed a $4 million partnership to build studio pads for single
                    professionals in Bangalore and offer Proptech Rental and Property Management
                    Services. The project will come up in IT belt in and around the city, and the idea is to
                    build high quality personal dwelling which is self-sufficient in all forms - be it easy
                    access to workplace or reasonable rentals.</p>
            </div>
        </div>
        <div class="col-md-6 col-12" style="margin-bottom: 24px;">
            <img src="assets/images/fiverings.png" class="img-responsive" style="width: 100%;"/>
        </div>
    </div>
</div>

<div class="pageWrapper" style="margin: 64px 0px">
    
    <div class="row" style="padding: 0px 40px"> 
        <div class="col-md-6 col-12">
            <div  id="google_map" >
                <agm-map 
                    [latitude]="latitude" 
                    [longitude]="longitude" 
                    [zoom]="zoom" 
                    style="height: 300px;">
                    <agm-marker 
                        [latitude]="latitude" 
                        [longitude]="longitude">
                    </agm-marker>
                </agm-map>
            </div>
        </div>
        <div class="col-md-6 md-12">
            <div class="detailsContainer">
                <div style="margin-bottom:24px;box-sizing:border-box;">
                    <ul class="nav nav-tabs header-tabs">
                        <li class="nav-item">
                            <p class="nav-link active" id="overview-tab" data-toggle="tab" data-target="#overview" >Project Overview</p>
                        </li>
                        <li class="nav-item">
                            <p class="nav-link" id="amenities-tab" data-toggle="tab" data-target="#amenities">Amenities</p>
                        </li>
                        <!-- <li class="nav-item">
                            <p class="nav-link" id="resources-tab" data-toggle="tab" data-target="#resources">Resources</p>
                        </li> -->
                    </ul>
                </div>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="overview" role="tabpanel" aria-labelledby="overview-tab">
                        <p class="contentText">EXD Five Rings project features health oriented sporting facilities like cricket nets, swimming pool, badminton court and a host of other luxurious facilities that cater to the needs of the entire family. The self-contained project offers high end class amenities and the very best infrastructure.</p>
                        <p class="contentText">Conveniently located on Sarjapur-Baglur Road, one of Bangalore's fastest growing corridors, the project not only offers great connectivity to major IT hubs and lifestyle destinations, but also is an excellent investment option.</p>
                    </div>
                    <div class="tab-pane fade" id="amenities" role="tabpanel" aria-labelledby="amenities-tab">
                        <ul class="amenities">
                            <li>Club house</li>
                            <li>Jogging track</li>
                            <li>Recreational center</li>
                            <li>Yoga room</li>
                            <li>Car wash and charging area</li>
                            <li>Car wash and charging area</li>
                            <li>CCTV surveillance</li>
                            <li>Parks and landscaped area</li>
                            <li>Kids play area</li>
                        </ul>
                    </div>
                    <!-- <div class="tab-pane fade " id="resources" role="tabpanel" aria-labelledby="resources-tab">
                        <div style="display: flex; justify-content: center; align-items: center; flex-direction: column; row-gap: 8px; height: 100%;">
                            <fa-icon [icon]="faFileAlt" style="font-size:40px; color: #828282" ></fa-icon>
                            <a href="../../../assets/files/EXD Five Rings Project Details  (1).pdf" target="_blank" style="cursor: pointer;font-size: 18px; color: #828282; font-family: 'Poppins', sans-serif;">Brochure</a>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
    <div style="padding: 0px 40px; margin: 88px 0px;">
        <p class="sectionHeader" style="font-weight: 600; margin-top: 8px; margin-bottom: 24px;">Project Plan Gallery</p>
        <div class="imageGallery" style="margin-top: 32px">
            <div class="projectImagesWrapper" data-toggle="modal" data-target="#masterPlanModal">
                <img src="../../../assets/images/fiverings_plan1.png"  class="projectImages"/>
            </div>
            <div class="projectImagesWrapper" data-toggle="modal" data-target="#planAModal">
                <img src="../../../assets/images/fiverings_typeA.png"  class="projectImages"/>
            </div>
            <div class="projectImagesWrapper" data-toggle="modal" data-target="#planBModal">
                <img src="../../../assets/images/fiverings_typeB.png"  class="projectImages"/>
            </div>
        </div>
    </div>
    <div class="row" style="margin: 32px 0px; padding: 0px 40px">
        <div class="col-md-2 col-12">
                <div  style="margin-bottom: 16px; ">
                    <img src="../../../assets/images/alok_rushmore.jpeg" style="width: 196px; height: 196px;">
                </div>
        </div>
        <div class="col-md-10 col-12" style="display: flex; align-items: center; justify-content: center;">
            <div class="memberQuotes" style=" width: 100%;">
                “In Bangalore’s 1.5 million strong IT Industry, around 45-50% professionals are in the
            age category of 21 to 27 years with less than 5 years of work experience and there’s
            a large demand for high quality, purpose-built mid-term stay studio apartments for
            them.” <br>- Alok Kumar Singh, Rushmore Estates.
            </div>
        </div>
        
    </div>
    <div class="row" style="margin: 32px 0px; padding: 0px 40px">
        
        <div class="col-md-10 col-12" style="display: flex; align-items: center; justify-content: center;">
            <div class="memberQuotes" style=" width: 100%;" >
                “Since Inception of YourOwnROOM, we’ve seen a huge gap between Demand for
                safe, secure and convenient homes and supply in Bangalore especially for folks in
                their early career. We are super excited to partner with Alok Singh and Rushmore to
                identify and create high quality supply and offer our prop-tech rental and property
                management solution to the Retail HomeOwners at the Point of Sale. This is also
                setting the blueprint for our sustainable future profitable growth in 2024 and beyond.”<br> - Prabhat Kumar Tiwary, Founder, MD& CEO, YourOwnROOM.
            </div>
        </div>
        <div class="col-md-2 col-12">
            <div  style="margin-bottom: 16px; ">
                <img src="../../../assets/images/prabhat_latest.jpeg" style="width: 196px; height: 196px;">
            </div>
        </div>
    </div>
    
</div>

<div class="modal fade" id="masterPlanModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <div class="modal-body">
                    <div style="display: flex; justify-content: center; align-items: center;">
                        <img src="../../../assets/images/fiverings_plan1.png"  class="projectModalImagesRect"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="planAModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <div class="modal-body">
                    <p class="contentSubText" style="font-weight: 600;">Type A</p>
                    <p class="contentSubText">Carpet Area: 247 sft | 22.95 sqm</p>
                    <p class="contentSubText">Saleable Area: 370 sft | 34.73 sqm</p>
                    <div style="display: flex; justify-content: center; align-items: center;">
                        <img src="../../../assets/images/fiverings_typeA.png"  class="projectModalImages"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="planBModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <div class="modal-body">
                    <p class="contentSubText" style="font-weight: 600;">Type B</p>
                    <p class="contentSubText">Carpet Area: 300 sft | 27.87 sqm</p>
                    <p class="contentSubText">Saleable Area: 474 sft | 44.03 sqm</p>
                    <div style="display: flex; justify-content: center; align-items: center;">
                        <img src="../../../assets/images/fiverings_typeB.png"  class="projectModalImages"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



